import styled, { css } from 'styled-components';
import { PropTypes } from 'prop-types';
import {
  primaryMixin,
  outlinePrimaryMixin,
  grayTextMixin,
  noBorderPrimaryMixin,
  smallMixin,
  forthMixin
} from './styles';
import { QuicksandBold } from '../Text';

const propTypes = {
  outlinePrimary: PropTypes.bool,
  type: PropTypes.string
};

const defaultProps = {
  outlinePrimary: false,
  type: 'button'
};

const Button2 = styled.button`
  display: block;
  padding: 8px 32px;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 48px;
  width: auto;
  white-space: nowrap;
  ${QuicksandBold}

  border: 0 none;
  border-radius: 8px;
  background: transparent;

  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease, border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;

  text-align: center;
  &:focus,
  &:active { outline: none; }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  ${({ outlinePrimary }) => outlinePrimary && outlinePrimaryMixin}
  ${({ text }) => text && grayTextMixin}
  ${({ primary }) => primary && primaryMixin}
  ${({ noBorderPrimary }) => noBorderPrimary && noBorderPrimaryMixin}
  ${({ forth }) => forth && forthMixin}

  ${({ sm }) => sm && smallMixin}

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}
`;

Button2.propTypes = propTypes;
Button2.defaultProps = defaultProps;

export default Button2;
